import RBS, { RbsRegion } from "@rettersoft/rbs-sdk"
import getConfig from 'next/config'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import SBheader from '../../components/SBheader'
import SBnewFooter from '../../components/SBnewFooter'
import { Button } from '../../components/button'
import { getLocale } from "../../helpers/stateFunctions"
import { isProd } from '../../helpers/utility'
const { publicRuntimeConfig } = getConfig()

export default function Index() {

    const state = useSelector((state) => state)
    let userLocale = getLocale(state) == "tr" ? "tr_TR" : "en_US"

    useEffect(() => {

    }, [])


    return (
        <div>
            <div>

                <SBheader />

                <main style={{ marginBottom: 30 }} className="sb-delivery height-100 flex flex-column">

                    <div className="sb-headerCrate flex flex-column bg-white  flex-shrink-none">
                        <div className="flex flex-grow flex-column ">
                            <div className="container--headerCrate sb-headerCrate--content size12of12 ">
                                <h1 className="sb-heading sb-heading--large text-bold" style={{ lineHeight: "36px" }} tabIndex={-1}>Delivers</h1></div>
                        </div>
                    </div>

                    <div style={{ backgroundColor: "#f7f7f7", marginBottom: 30 }} className="sb-contentCrate flex-grow ">
                        <div className="relative flex-auto">
                            <div className="flex-auto">
                                <div className="delivers-content">
                                    <div className="top-content">
                                        <div className="top-logo">
                                            <img className="sb-logo-reserve" src="https://content.sbuxtr.com/images/ui/StarbucksDelivers_white_rgb-01.png" />
                                            <img className="sb-logo-pin" src="https://content.sbuxtr.com/images/ui/delivery_pin.png" />
                                            <p className="sb-bot-txt">STARBUCKS®'TAN SİPARİŞ VERMEK <br /> ŞİMDİ ÇOK DAHA KOLAY</p>
                                            <img className="sb-top-bg" src="https://content.sbuxtr.com/images/ui/SBUX-UE-Handoff-2939_SO-retouched.jpg" />
                                        </div>
                                    </div>

                                    <div className="mid-content">
                                        <h3 className="mid-title">HEMEN SİPARİŞ VER</h3>
                                        <p>Hemen sipariş ver, sevdiğin Starbucks® lezzetleri olduğun yere teslim edilsin.</p>
                                        <div className="comp-logo">
                                            <a href="https://www.starbucks.com.tr/delivers/delivery-yemeksepeti">
                                                <div className="ys-logo">
                                                    <img src="https://content.sbuxtr.com/images/ui/yemeksepeti-logo.svg" />
                                                </div>
                                            </a>
                                            <a href="https://www.starbucks.com.tr/delivers/delivery-getir">
                                                <div className="gy-logo">
                                                    <img src="https://content.sbuxtr.com/images/ui/getiryemek-logo.svg" />
                                                </div>
                                            </a>

                                        </div>
                                    </div>

                                    <div className="foot-content">
                                        <p>Menü seçenekleri sınırlıdır. Belirli bölgelere servis yapılmaktadır. Sadece katılımcı restoranlarda geçerlidir. Eve teslim siparişi hizmeti veren firmaların uygulamaları üzerinden satın alınan Starbucks® ürünlerinin fiyatları restoranlarda belirtilenden farklı olabilir. </p>
                                        <p>Daha fazla bilgi için firmaların uygulamalarına bakınız. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{paddingTop:"50px"}}></div>
                        <SBnewFooter />
                    </div>
                </main>
            </div >
        </div >
    )
}